module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L4-e43666a702023cf33f248b1a3d4be48b.png";